export default function StepContent({ children, testId }) {
  return (
    <div className="flex flex-column my-4" data-testid={testId}>
      <div className="flex-auto flex flex-column gap-4 font-medium">
        {children}
      </div>
    </div>
  );
}
